import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PlayerListListViewModel } from '../../models/PlayerListModels';


import { RouterModule, RouterLink } from '@angular/router';
import { MatCard, MatCardHeader, MatCardAvatar, MatCardTitle, MatCardSubtitle, MatCardContent, MatCardActions } from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';
import { MatAnchor } from '@angular/material/button';

@Component({
    selector: 'app-ranking-list-card',
    //standalone: true,
    //imports: [CommonModule, RouterModule, RankingListCardComponent, SharedModuleModule],
    templateUrl: './ranking-list-card.component.html',
    styleUrls: ['./ranking-list-card.component.css'],
    imports: [MatCard, MatCardHeader, MatIcon, MatCardAvatar, MatCardTitle, MatCardSubtitle, MatCardContent, MatCardActions, MatAnchor, RouterLink]
})
export class RankingListCardComponent implements OnInit {

  @Input() List: PlayerListListViewModel;
  @Output() onCopyListClicked =  new EventEmitter<PlayerListListViewModel>();
  @Output() onDeleteListClicked = new EventEmitter<PlayerListListViewModel>();
  @Output() onArchiveListClicked = new EventEmitter<PlayerListListViewModel>();
  
  constructor() { }

  ngOnInit() {
  }

}
